import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  routes: [

    {
      path:'/',
      name:'home',
      redirect:'/home',
      component:(resolve) => require(['@/pages/home/index'],resolve),
      meta: {
        title: '创新化药-数据总览'
      }
    },
    {
      path:'/home',
      name:'home',
      component:(resolve) => require(['@/pages/home/index'],resolve),
      meta: {
        title: '创新化药-数据总览'
      }
    },
    {
      path:'/searchQuery',
      name:'searchQuery',
      component:(resolve) => require(['@/pages/searchQuery/index'],resolve),
      meta: {
        title: '创新化药-数据查询'
      }
    },
    {
      path:'/rdStatus',
      name:'rdStatus',
      component:(resolve) => require(['@/pages/rdStatus/index'],resolve),
      meta: {
        title: '创新化药-研发动态'
      }
    },
    {
      path:'/promptPage',
      name:'promptPage',
      component:(resolve) => require(['@/pages/promptPage/index'],resolve),
      meta: {
        title: '创新化药-提示'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js